module.exports = __webpack_public_path__ + "cbedf87266e50fc32e784bd0d043971f.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/mora.png
// module id = 613
// module chunks = 0